import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
const rows = [{
  label: '📚 NEURO-RUNNING PACK (12 Tomos)',
  price: '$15'
}, {
  label: '🎁 Calculadora de Ritmos-Eficientes',
  price: 'GRATIS'
}, {
  label: '🎁 Protocolo de Calentamiento Mental',
  price: 'GRATIS'
}, {
  label: '🎁 Plan de Recuperación Cognitiva',
  price: 'GRATIS'
}, {
  label: '🎁 Plan de Alimentación Neuro-Energética',
  price: 'GRATIS'
}, {
  label: '🎁 Checklist Pre-Carrera Sin Estrés',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Débito / Crédito'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="border-y border-azul/10 bg-ink-2" data-id="element-197" data-mp="35pmzto7d5ouc">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "6px"
    }} data-id="element-198" data-mp="1tg4uqfp8fnpm">
        <h2 className="font-display text-2xl font-bold text-white sm:text-4xl" data-id="element-199" data-mp="1ohl5a5bfjtsi">🚀 Empezá hoy</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-white/60" style={{
        paddingTop: "25px",
        marginTop: "-20px",
        marginBottom: "-20px"
      }} data-id="element-200" data-mp="2367set7atpua">
          Por menos de lo que cuesta un gel energético tenés acceso de por vida. Todo el sistema
          listo para aplicar en minutos.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-azul/15 bg-ink text-left" style={{
        marginTop: "25px",
        marginBottom: "25px"
      }} data-id="element-201" data-mp="283hhu8uou1i4">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-202" data-mp="2h4fnswoosj3c">
            <span data-id="element-203" data-mp="rq9fufcwwlob">Qué incluye</span>
            <span data-id="element-204" data-mp="mr69mrl749er">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 py-3.5 text-sm" style={{
          paddingTop: "1px"
        }} data-id="element-205" data-mp="msr3sg3llqc3">
              <span className="text-white/80" data-id="element-206" data-mp="2rrh516t14ncc">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-azul-soft'} data-id="element-207" data-mp="2ru3krtq2q95n">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-azul/15 px-5 py-4" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-208" data-mp="30qknq9oab0qb">
            <span className="text-sm font-bold text-white" data-id="element-209" data-mp="3aq36wnwdeihb">
              Valor total real: <span className="text-white/40 line-through" data-id="element-210" data-mp="3fhbgpl1m45v0">$76</span>
            </span>
            <span className="text-plata-shine font-display text-2xl font-bold" data-id="element-211" data-mp="3jj6s5id9bzmi">$15</span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-212" data-mp="3ojawyb4sz5ww">
          <CTAButton href={CHECKOUT_URL} data-id="element-213" data-mp="3ogf0kr8lspak">✅ Obtener Neuro-Running Pack</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-214" data-mp="3tfi5mbol2vij">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap" data-id="element-215" data-mp="2fhcoaokfbi8">
              <Icon className="h-4 w-4 text-plata" data-id="element-216" data-mp="3to4zkv2gf6rw" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}